export default __webpack_public_path__ + "static/media/scenarioo.8fd2e669.png";